import type {
    AtribuirRegiaoModel,
    BairroRegiao,
    CidadeView,
} from "../models/atribuirRegiaoModel"

export enum AtribuirRegiaoActionsTypes {
    CARREGAR_BAIRROS = "CARREGAR_BAIRROS",
    CARREGAR_CIDADES_ESTABELECIMENTO = "CARREGAR_CIDADES_ESTABELECIMENTO",
    CARREGAR_TODAS_CIDADES = "CARREGAR_TODAS_CIDADES",
    ADICIONAR_BAIRRO = "ADICIONAR_BAIRRO",
    ATUALIZAR_BAIRRO = "ATUALIZAR_BAIRRO",
    REMOVER_BAIRRO = "REMOVER_BAIRRO",
}

export type AtribuirRegiaoActionModel =
    | {
          type: AtribuirRegiaoActionsTypes.CARREGAR_BAIRROS
          payload: BairroRegiao[]
      }
    | {
          type: AtribuirRegiaoActionsTypes.CARREGAR_CIDADES_ESTABELECIMENTO
          payload: CidadeView[]
      }
    | {
          type: AtribuirRegiaoActionsTypes.CARREGAR_TODAS_CIDADES
          payload: CidadeView[]
      }
    | {
          type: AtribuirRegiaoActionsTypes.ADICIONAR_BAIRRO
      }
    | {
          type: AtribuirRegiaoActionsTypes.ATUALIZAR_BAIRRO
          payload: { index: number; campo: keyof BairroRegiao; valor: string | number | null }
      }
    | {
          type: AtribuirRegiaoActionsTypes.REMOVER_BAIRRO
          payload: { index: number }
      }
